import { ref } from "vue";

export enum Theme {
    CMS = 'cms',
    Yapla = 'yapla'
};

const theme = ref(Theme.Yapla);

export const useTheme = () => {
    const setTheme = (newTheme: Theme) => {
        theme.value = newTheme;
    };

    const cms = (classes: string) => {
        return theme.value === Theme.CMS ? classes : '';
    };

    const yapla = (classes: string) => {
        return theme.value === Theme.Yapla ? classes : '';
    };

    return {
        theme,
        cms,
        yapla,
        setTheme
    }
};